import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DropZoneContainer from './DropZoneContainer';
import InputComponent from './InputComponent';
import MuiDialogContent from '@material-ui/core/DialogContent';
import React, { useState, useEffect, useRef } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import clsx from 'clsx';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { ReactComponent as CloseIcon } from '../assets/svg/icon_close.svg';
import { fetchData, showSuccess } from '../common/app/actions';
import { getText, getPath } from '../common/utils/helpers';
import { sendFormData } from '../common/app/actions';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  StyleRules,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme: Theme): StyleRules =>
    createStyles({
      addContainerStyle: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
      },
      addWrapperStyle: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // maxWidth: `${C.MAX_WIDTH}px`,
        width: '100%',
        height: '100%',
        // padding: '24px 50px',
      },
      headerContainerStyle: {
        position: 'relative',
        width: '100%',
        // minHeight: '90px',
        display: 'flex',
        flexDirection: 'row',
        // border: 'gray solid 1px',
      },
      addTitleStyle: {
        width: '100%',
        // height: 'auto',
        // fontSize: '16px',
        // lineHeight: '22px',
        // background: 'transparent',
        // outline: 'none',
        // // border: 'none',
        // resize: 'none',
        // overflow: 'hidden',
        // boxShadow: 'none',
        // padding: '20px',
        margin: 0,
      },
      contentContainerStyle: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        paddingTop: '20px',
      },
      annotationStyle: {
        resize: 'vertical',
        margin: '0 0 20px 12px',
      },
      dateStyle: {
        margin: '0 0 20px 12px',
      },
      placeStyle: {
        margin: '0 0 20px 12px',
      },
      nameStyle: {
        margin: '0 0 0 12px',
      },
      descriptionTextStyle: {
        width: '290px',
        height: '730px',
        minWidth: '290px',
        minHeight: '727px',
        textAlign: 'justify',
        margin: '0 14px 0 0',
      },
      btnContainerStyle: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
      },
      btnStyle: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '250px',
        maxWidth: '250px',
        minHeight: '68px',
        width: '100%',
        // padding: '20px 0',
        backgroundColor: COLORS.appSand,
        boxShadow: '11px 10px 26px -9px rgba(0, 0, 0, 0.64)',
        cursor: 'pointer',
        textAlign: 'center',
        fontWeight: FONT_WEIGHT.bold,
        color: COLORS.appBrown,
        fontSize: '20px',
        fontFamily: FONTS.source,
        pointerEvents: 'auto',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            backgroundColor: COLORS.appDarkSand,
            transition: '0.5s ease',
          },
        },
      },
      btnProgressStyle: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '30%',
        minHeight: '68px',
        width: '100%',
        marginBottom: '50px',
      },
      centerContainerStyle: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '30vh',
      },
      rightContainerStyle: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
      dropZoneParentContainerStyle: {
        marginBottom: '10px',
      },
      disclaimerTextStyle: {
        position: 'relative',
        margin: '30px 0',
        lineHeight: '24px',
        fontSize: '18px',
        textAlign: 'justify',
      },
      disclaimerButtonStyle: {
        minWidth: '250px',
        maxWidth: '250px',
        cursor: 'pointer',
        marginBottom: '50px',
      },
      progressStyle: {
        position: 'absolute',
        bottom: 0,
        padding: '10px',
      },
      errorContainerStyle: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        height: '40px',
      },
      errorStyle: {
        color: COLORS.red,
      },
      dialogContainerStyle: {
        '& > div > div': {
          maxWidth: `${C.MAX_WIDTH}px`,
          width: '100%',
          background: COLORS.white,
        },
      },
      closeButtonStyle: {
        position: 'absolute',
        right: theme.spacing(2),
        top: theme.spacing(2),
        fill: COLORS.textGray,
        width: '40px',
        height: '40px',
        pointerEvents: 'auto',
        zIndex: 100,
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
      dialogContentStyle: {
        margin: '16px',
        color: COLORS.appBrown,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
      },
      [`@media (max-width: 950px)`]: {
        disclaimerWrapperStyle: {
          height: '100%',
          justifyContent: 'flex-start',
        },
      },
      [`@media (max-width: 800px)`]: {
        contentContainerStyle: {
          flexDirection: 'column',
        },
        descriptionTextStyle: {
          width: '100%',
          height: 'auto',
          marginBottom: '20px',
          resize: 'vertical',
          minWidth: '100%',
          minHeight: '88px',
        },
      },
    })
);

const AlbumAdd = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const lng = useSelector((state) => state.app.lng);
  const addData = useSelector((state) => state.app.addData);
  const [image, setImage] = useState(null);

  const headerRef = useRef<any>();
  const textRef = useRef<any>();
  const imageTextRef = useRef<any>();
  const timeRef = useRef<any>();
  const placeRef = useRef<any>();
  const emailRef = useRef<any>();

  const [isDisclaimerVisible, setDisclaimer] = useState(false);
  const [isProgress, setProgress] = useState(false);
  const [isError, setError] = useState(false);

  useEffect(() => {
    dispatch(fetchData(C.ADD_DATA, { add: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!addData) {
    return (
      <div className={classes.centerContainerStyle}>
        <CircularProgress />
      </div>
    );
  }

  const onImageAdd = (passedImage) => {
    setImage(passedImage);
  };

  const titlePlaceholder: string = getText(addData?.content, 'title', lng);
  const textPlaceholder: string = getText(addData?.content, 'text', lng);
  const uploadInfo: string = getText(addData?.content, 'upload', lng);
  const annotationPlaceholder: string = getText(
    addData?.content,
    'annotation',
    lng
  );
  const datePlaceholder: string = getText(addData?.content, 'date', lng);
  const placePlaceholder: string = getText(addData?.content, 'place', lng);
  const namePlaceholder: string = getText(addData?.content, 'name', lng);
  const buttonLabel: string = getText(addData?.content, 'button', lng);
  const progressLabel: string = getText(addData?.content, 'progress', lng);
  const validationLabel: string = getText(addData?.content, 'validation', lng);
  const rawDisclaimerText: string = getText(
    addData?.content,
    'disclaimer',
    lng
  );
  const disclaimerText: string = rawDisclaimerText.replace(
    /(?:\r\n|\r|\n)/g,
    '<br>'
  );

  const successLabel: string = getText(addData?.content, 'success', lng);

  const getFieldsData = () => {
    return {
      header: headerRef.current.value,
      text: textRef.current.value,
      image_text: imageTextRef.current.value,
      time: timeRef.current.value,
      place: placeRef.current.value,
      email: emailRef.current.value,
    };
  };

  const onSendClick = async (event: React.SyntheticEvent) => {
    event.stopPropagation();
    event.preventDefault();

    const formData = new FormData();
    formData.append('file', image);

    const fieldsData = getFieldsData();

    Object.keys(fieldsData).forEach((fieldName) => {
      formData.append(fieldName, fieldsData[fieldName]);
    });

    setProgress(true);

    try {
      const data = await dispatch(sendFormData(formData));

      if (data === 'success') {
        dispatch(showSuccess(successLabel));
        history.push(ROUTES.ROOT);
      }
    } catch (e) {
      console.log('error', e);
    } finally {
      setProgress(false);
      setDisclaimer(false);
    }
  };

  const onSubmitClick = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    event.preventDefault();

    const fieldsData = getFieldsData();

    const isNotCompleted = Object.keys(fieldsData).some((fieldName) => {
      const fieldValue = fieldsData[fieldName];

      return !Boolean(fieldValue);
    });

    if (!isNotCompleted && image) {
      setError(false);
      setDisclaimer(true);
    } else {
      setError(true);
    }
  };

  const onClose = async (event: React.SyntheticEvent) => {
    event.stopPropagation();
    event.preventDefault();

    setDisclaimer(false);
  };

  const isMobile = window.innerWidth < 900;

  const getDisclaimer = () => {
    return (
      <Dialog
        fullScreen={isMobile}
        open={true}
        onClose={onClose}
        className={classes.dialogContainerStyle}
      >
        <CloseIcon className={classes.closeButtonStyle} onClick={onClose} />
        <MuiDialogContent className={classes.dialogContentStyle}>
          <div
            className={classes.disclaimerTextStyle}
            dangerouslySetInnerHTML={{
              __html: disclaimerText,
            }}
          />
          {isProgress ? (
            <div className={classes.btnProgressStyle}>
              <CircularProgress />
            </div>
          ) : (
            <div
              className={clsx(classes.btnStyle, classes.disclaimerButtonStyle)}
              onClick={onSendClick}
            >
              {buttonLabel}
            </div>
          )}
          {isProgress && (
            <div className={classes.progressStyle}>{progressLabel}</div>
          )}
        </MuiDialogContent>
      </Dialog>
    );
  };

  const getLimit = (fieldName) => {
    const itemLimit = addData?.content[`${fieldName}_limit`] || '100';

    return parseInt(itemLimit);
  };

  return (
    <div className={classes.addContainerStyle}>
      <div className={classes.addWrapperStyle}>
        <div className={classes.headerContainerStyle}>
          <InputComponent
            className={classes.addTitleStyle}
            placeholder={titlePlaceholder}
            maxLength={getLimit('title')}
            passedRef={headerRef}
          />
        </div>
        <div className={classes.contentContainerStyle}>
          <InputComponent
            className={classes.descriptionTextStyle}
            placeholder={textPlaceholder}
            maxLength={getLimit('text')}
            passedRef={textRef}
          />
          <div className={classes.rightContainerStyle}>
            <div className={classes.dropZoneParentContainerStyle}>
              <DropZoneContainer onImageAdd={onImageAdd} info={uploadInfo} />
            </div>
            <InputComponent
              className={classes.annotationStyle}
              placeholder={annotationPlaceholder}
              maxLength={getLimit('annotation')}
              passedRef={imageTextRef}
            />
            <InputComponent
              className={classes.dateStyle}
              placeholder={datePlaceholder}
              maxLength={getLimit('date')}
              type="text"
              passedRef={timeRef}
            />
            <InputComponent
              className={classes.placeStyle}
              placeholder={placePlaceholder}
              maxLength={getLimit('place')}
              type="text"
              passedRef={placeRef}
            />
            <InputComponent
              className={classes.nameStyle}
              placeholder={namePlaceholder}
              maxLength={getLimit('name')}
              type="text"
              passedRef={emailRef}
            />
          </div>
        </div>
        <div className={classes.errorContainerStyle}>
          {isError && (
            <div className={classes.errorStyle}>{validationLabel}</div>
          )}
        </div>
        <div className={classes.btnContainerStyle}>
          <div className={classes.btnStyle} onClick={onSubmitClick}>
            {buttonLabel}
          </div>
        </div>
      </div>
      {isDisclaimerVisible && getDisclaimer()}
    </div>
  );
};

export default AlbumAdd;
